import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 单号抄录
export function searchCargoDoc(params) {
  return request({
    url: URL.seaExport.searchCargoDoc,
    method: 'get',
    params
  })
}

// 更新提单
export function updateCargoDoc(data, params) {
  return request({
    url: URL.seaExport.updateCargoDoc,
    method: 'put',
    data,
    params
  })
}

// 根据jobNos查出来委托单位是否是否黑名单
export function checkCustomsBlackName(data) {
  return request({
    url: URL.booking.checkCustomsBlackNameUrl,
    method: 'post',
    data
  })
}
// 根据uuid和放单审核加载cargoDoc
export function loadCargoDocKeysByReleaseReview(data) {
  return request({
    url: URL.booking.checkCargoDocKeysForStatusUrl,
    method: 'post',
    data
  })
}
export function batchAuditSingleRelease(data) {
  return request({
    url: URL.booking.batchAuditSingleReleaseUrl,
    method: 'post',
    data
  })
}
export function batchAuditSingleReleaseHbl(data) {
  return request({
    url: URL.booking.batchAuditSingleReleaseHblUrl,
    method: 'post',
    data
  })
}
// 主单放单管理-放单审核
export function querySingleReleaseVerifyPageableFunc(data) {
  return request({
    url: URL.booking.querySingleReleaseVerifyPageableUrl,
    method: 'post',
    data
  })
}

// 根据主键获取箱号
export function getContainerNoFunc(params) {
  return request({
    url: URL.seaExport.getContainerNoUrl,
    method: 'get',
    params
  })
}

// 主单放单管理-放单审核- 加载费用
export function loadChargesFunc(params) {
  return request({
    url: URL.booking.getChargesUrl,
    method: 'get',
    params
  })
}

// 主单放单管理-完成 - 更新费用和提单状态
export function updateChargeAndDocFunc(data, params) {
  return request({
    url: URL.booking.updateChargeAndDocUrl,
    method: 'post',
    data,
    params
  })
}

// 获取ISF乘客
export function getIsfPassenger(params) {
  return request({
    url: URL.seaExport.getIsfPassenger,
    method: 'get',
    params
  })
}

// 获取ISF乘客
export function searchAfrAddress(data) {
  return request({
    url: URL.seaExport.searchAfrAddress,
    method: 'post',
    data
  })
}

export function searchYfAfrAddress(data) {
  return request({
    url: URL.seaExport.searchYfAfrAddress,
    method: 'post',
    data
  })
}

// 查询保单
export function queryInsure(params) {
  return request({
    url: URL.seaExport.queryInsure,
    method: 'get',
    params
  })
}
// 特批放单
export function specialApprovalOrder(data) {
  return request({
    url: URL.seaExport.specialApprovalOrder,
    method: 'post',
    data
  })
}
// 导出泰国舱单
export function exportThailand(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.exportThailand,
    method: 'post',
    data
  })
}
